<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>用户管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/normal_user_out_black_list')">提现黑名单管理</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='关键字'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入姓名、手机号"
            >
              <el-button
                slot="append"
                v-on:click="handleSearch"
              >搜索</el-button>

            </el-input>
            <el-button v-if="hasPower('40201991')"
              type="success"
              v-on:click="showEditGroup1"
            >新增黑名单</el-button>
            <span style="color: #666;line-height: 28px;font-size:14px;">注意:搜索结果将在下方列表呈现。</span>
          </el-form-item>


        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          v-loading='tableDataLoading'
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="用户昵称"
          >

          </el-table-column>

          <el-table-column
            prop="telephone"
            label="手机号"
          >
          </el-table-column>

          <el-table-column :formatter="formatterRoleType" prop="role_type" label="代理级别"></el-table-column>

          <el-table-column
            prop="splitRatio"
            label="公司获得比例"
          >
          <template slot-scope="scope">
            {{scope.row.splitRatio}}%
          </template>
          </el-table-column>

          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">

              <el-dropdown v-if="hasPower('40011991')">
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="scope.row.status==2"
                    command="a"
                    @click.native="upHouseStatus(scope.row, 1)"
                  >恢复</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.status==1"
                    command="b"
                    @click.native="upHouseStatus(scope.row, 2)"
                  >禁用</el-dropdown-item>
                  <el-dropdown-item
                    command="c"
                    @click.native="upHouseStatus(scope.row, 3)"
                  >修改比例</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>

            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog title="修改公司获得比例 " :visible.sync="dialogEditPassVisible" width="30%">

      <el-form label-position="top" class="m-search" size='small' ref="form" :model="form" :rules="editPassRule">
        <el-form-item label="公司获得比例" prop="splitRatio">
          <el-input v-model="form.splitRatio" placeholder="请输入公司获得比例，0-100之间" type="Number" :max="100" :min="0"
            @input="changeSplitRatio">
          </el-input>用户提现10000，那么公司抽取{{showSplitRatio}}
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="changePass()" :loading="addPassLoading">提交</el-button>
          <el-button @click="dialogEditPassVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改管理员"
      :visible.sync="dialogEditVisible"
      width="30%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        ref="form1"
        :model="form1"
        :rules="editUserRule"
      >
        <el-form-item
          label="姓名"
          prop="username"
        >
          <el-input
            v-model="form1.username"
            placeholder="请输入姓名"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telephone">
          <el-input
            v-model="form1.telephone"
            placeholder="请输入手机号"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input
            v-model="form1.email"
            placeholder="请输入邮箱"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input
            v-model="form1.id_code"
            placeholder="请输入身份证"
          >
          </el-input>
        </el-form-item>


           <el-form-item label="用户类型">
            <el-select disabled
              v-model="form1.user_type"
              placeholder="请选择"
            >
              <el-option
                label="平台管理员"
                value="1"
              ></el-option>
              <el-option
                label="区域管理员"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>

           <el-form-item label="登录权限">
            <el-select
              v-model="form1.login_type"
              placeholder="请选择"
            >
              <el-option
                label="pc+小程序"
                value="1"
              ></el-option>
              <el-option
                label="pc"
                value="2"
              ></el-option>
              <el-option
                label="小程序"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="throwGroupUp()"
            :loading="addLoading"
          >提交</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="新增黑名单"
      :visible.sync="dialogEditVisible1"
      width="30%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        ref="form"
        :model="form"
        :rules="addUserRule"
      >
          <el-form-item label="手机号" prop="telephone">
            <el-input
              v-model="form.telephone"
              placeholder="请输入手机号"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="公司获得比例" prop="splitRatio">
            <el-input
              v-model="form.splitRatio"
              placeholder="请输入公司获得比例，0-100之间"
              type="Number"
              :max="100"
              :min="0"
              @input="changeSplitRatio"
            >
            </el-input>用户提现10000，那么公司抽取{{showSplitRatio}}
          </el-form-item>

          <el-button
            type="primary"
            @click="throwGroupUp1()"
            :loading="addLoading1"
          >提交</el-button>
          <el-button @click="dialogEditVisible1 = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="修改权限"
      :visible.sync="dialogRoleVisible"
      width="30%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        ref="roleForm"
        :model="roleForm"
        :rules="addUserRule"
      >
        <el-form-item>
          <el-tree
            :data="data4"
            ref="tree2"
            show-checkbox
            node-key="id"
            :default-checked-keys="powers"
            @check="handleNodeClick"
            :props="defaultProps"
          >
          </el-tree>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="editRole()"
            :loading="roleLoading"
          >提交</el-button>
          <el-button @click="dialogRoleVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>

</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
var _ = require("lodash");
var validatePhone = (rule, value, callback) => {
  if (value === "") {
    callback();
  } else {
    if (
      !/^((1[3-9][0-9]))\d{8}$|^(5|6|8|9)\d{7}$|^\d{3,4}-\d{7,8}$|^(852)?(2[1-9]|3[145679])\d{6}$/.test(
        value
      )
    ) {
      callback(new Error("手机号格式出错"));
    } else {
      callback();
    }
  }
}
export default {
  name: "manager_user_list",
  created() {},
  data() {
    return {
      powers:[],
      roleForm: {
        id: null,
        powers: null
      },
      data4:[],
      data2: [
        {
          id: 10001,
          label: "首页管理",
          children: [
            {
              id: 10011,
              label: "查看轮播图"
            },
            {
              id: 10011991,
              label: "编辑轮播图"
            },
            {
              id: 10021,
              label: "查看热搜"
            },
            {
              id: 10021991,
              label: "编辑热搜"
            }
          ]
        },
        {
          id: 20001,
          label: "业务管理",
          children: [
            {
              id: 20011,
              label: "查看服务订单"
            },
            {
              id: 20011991,
              label: "编辑服务订单"
            },
            {
              id: 20021,
              label: "查看素材"
            },
            {
              id: 20021991,
              label: "编辑素材"
            },
            {
              id: 20031,
              label: "查看投诉"
            },
            {
              id: 20031991991,
              label: "编辑投诉"
            },
            {
              id: 20041,
              label: "查看服务订单类型"
            },
            {
              id: 20041991,
              label: "编辑服务订单类型"
            },
            {
              id: 20051,
              label: "查看素材类型"
            },
            {
              id: 20051991,
              label: "编辑素材类型"
            },
          ]
        },
        {
          id: 30001,
          label: "商城管理",
          children: [
            {
              id: 30011,
              label: "查看商品"
            },
             {
              id: 30011991,
              label: "编辑商品"
            },
            {
              id: 30021,
              label: "查看订单"
            },
            {
              id: 30021991,
              label: "编辑订单"
            },{
              id: 30021992,
              label: "编辑备注"
            },
            {
              id: 30051,
              label: "查看202012月活动订单"
            },
             {
              id: 30051991,
              label: "编辑202012月活动订单"
            },
            {
              id: 30031,
              label: "查看库存"
            },
            {
              id: 30031991,
              label: "编辑库存"
            },
            {
              id: 30041,
              label: "查看库存变动"
            },
            {
              id: 30041991,
              label: "编辑库存变动"
            },
            {
              id: 30081,
              label: "查看换货"
            },
            {
              id: 30081991,
              label: "编辑换货"
            },
            {
              id: 30082,
              label: "系列管理"
            },
            {
              id: 30082991,
              label: "编辑系列"
            },
            {
			        id: 30081992,
			        label: "修改到货数量和到货时间"
		        },
            {
              id: 30091,
              label: "查看订单"
            },
            {
              id: 30091991,
              label: "编辑订单"
            },{
              id: 30091992,
              label: "编辑备注"
            },

            // ,
            // {
            //   id: 30051,
            //   label: "补货订单审核"
            // }

          ]
        },
        {
          id: 40001,
          label: "用户管理",
          children: [
            {
              id: 40011,
              label: "查看员工"
            },
             {
              id: 40011991,
              label: "编辑员工"
            },
            {
              id: 40021,
              label: "查看代理"
            },
            {
              id: 40021991,
              label: "编辑代理"
            },
            {
              id: 40031,
              label: "查看代理申请"
            },
            {
              id: 40031991,
              label: "编辑代理申请"
            },
            {
              id: 40041,
              label: "查看门店"
            },
            {
              id: 40041991,
              label: "编辑门店"
            },
            {
            id: 40091,
            label: "查看服务商设置"
            },
            {
            id: 40091991,
            label: "编辑服务商设置"
            },
            {
            id: 40101,
            label: "查看销售公司设置"
            },
            {
            id: 40101991,
            label: "编辑销售公司设置"
            },
            {
              id: 40051,
              label: "门店搜索记录"
            },
            {
              id: 40071,
              label: "查看店铺修改审核"
            },
            {
              id: 40071991,
              label: "编辑店铺修改审核"
            },
            {
              id: 40081,
              label: "查看区域"
            },
            {
              id: 40081991,
              label: "编辑区域"
            },
            {
              id: 40201,
              label: "查看提现黑名单"
            },
            {
              id: 40201991,
              label: "编辑提现黑名单"
            },
          ]
        },
        {
          id: 50001,
          label: "资金管理",
          children: [
          {
			id: 51051,
			label: "直接打款"
		  },
            {
              id: 50051,
              label: "学习积分明细"
            },
            {
              id: 50052,
              label: "保证金明细"
            },
            {
              id: 50053,
              label: "用户积分明细"
            },
            {
              id: 50011,
              label: "充值管理"
            },
            {
              id: 50021,
              label: "查看一级提现审核"
            },
            {
              id: 50021991,
              label: "编辑一级提现审核"
            },
            // {
            //   id: 50031,
            //   label: "余额转账管理"
            // },
            {
              id: 50041,
              label: "查看红包"
            },
            {
              id: 50041991,
              label: "编辑红包"
            },
            {
              id: 50051,
              label: "查看提现交易记录"
            },
            {
              id: 50201,
              label: "查看黑名单提现交易记录"
            },
            {
              id: 50051991,
              label: "编辑二级提现审核"
            },
            // {
            //   id: 50061,
            //   label: "查看后台修改余额审核"
            // },
            // {
            //   id: 50061991,
            //   label: "编辑后台修改余额审核"
            // },
            {
              id: 50081,
              label: "查看保证金修改审核"
            },
            {
              id: 50081991,
              label: "编辑保证金修改审核"
            },
            {
              id: 50071,
              label: "支付宝微信交易记录"
            },
            {
              id: 50091,
              label: "直接进公司金额明细管理"
            },
            {
              id: 50101,
              label: "待补货金额明细管理"
            }
            ,
            {
              id: 50111,
              label: "查看一级小煜提现审核"
            }
            ,
            {
              id: 50111991,
              label: "编辑一级小煜提现审核"
            }
            ,
            {
              id: 50121,
              label: "查看二级小煜提现审核"
            }
            ,
            {
              id: 50121991,
              label: "编辑二级小煜提现审核"
            }
            ,
            {
              id: 50131,
              label: "查看小煜"
            }
            ,
            {
              id: 50131991,
              label: "编辑小煜"
            }
            ,
            {
              id: 50141,
              label: "直属小煜明细"
            },
            {
              id: 50151,
              label: "平台户交易明细"
            },
            // {
            //   id: 50161,
            //   label: "查看服务商奖金释放设置"
            // },
            // {
            //   id: 50161888,
            //   label: "操作服务商奖金释放设置"
            // },
            {
              id: 50171,
              label: "蕊匠交易记录"
            },
            {
              id: 50181,
              label: "城市加盟商季度考核"
            },
          ]
        },
        {
          id: 60001,
          label: "通用管理",
          children: [
            {
              id: 60011,
              label: "查看商品分类"
            },
            {
              id: 60011991,
              label: "编辑商品分类"
            },
            {
              id: 60021,
              label: "查看平台通知"
            },
            {
              id: 60021991,
              label: "编辑平台通知"
            },
            {
              id: 60031,
              label: "查看银行"
            },
            {
              id: 60031991,
              label: "编辑银行"
            },
            {
              id: 60041,
              label: "查看字典"
            },
            {
              id: 60041991,
              label: "编辑字典"
            },
            {
              id: 60051,
              label: "查看升级规则"
            },
            {
              id: 60051991,
              label: "编辑升级规则"
            },
            // {
            //   id: 60061,
            //   label: "考核设置"
            // },
            {
              id: 60071,
              label: "关于我们"
            },
            {
              id: 60081,
              label: "查看注册协议"
            },
            {
              id: 60081991,
              label: "编辑注册协议"
            },
            {
              id: 60091,
              label: "意见反馈"
            },
            {
              id: 60101,
              label: "查看Android版本"
            },
            {
              id: 60101991,
              label: "编辑Android版本"
            },
            {
              id: 60111,
              label: "查看月度返利梯度"
            },
            {
              id: 60111991,
              label: "编辑月度返利梯度"
            },
            {
              id: 60121,
              label: "查看收款POS"
            },
            {
              id: 60121991,
              label: "编辑收款POS"
            },
            {
              id: 60122,
              label: "操作日志"
            },
            {
            id: 60131,
            label: "错误日志"
            }
          ]
        },
        {
          id: 70001,
          label: "统计管理",
          children: [
            {
              id: 70250,
              label: "导出任务记录"
            },
            {
              id: 70301,
              label: "货物价值统计"
            },
            {
              id: 70011,
              label: "商品销量统计"
            },
            {
              id: 70251,
              label: "手工操作商品销量统计"
            },
            {
              id: 70261,
              label: "调换货商品销量统计"
            },
            {
              id: 70271,
              label: "商品销量统计(营销)"
            },
            {
              id: 70021,
              label: "代理人数新增统计"
            },
            {
              id: 70031,
              label: "考核业绩统计"
            },
            {
              id: 70041,
              label: "保证金汇总统计"
            },
            {
              id: 70051,
              label: "进销存汇总统计"
            },
            {
              id: 70061,
              label: "经销商虚拟库存汇总统计"
            },
            {
              id: 70071,
              label: "经销商虚拟库存明细表"
            },
            {
              id: 70081,
              label: "经销商账户往来款"
            },
            {
              id: 70091,
              label: "年度考核统计"
            },
            {
              id: 70101,
              label: "推荐积分汇总表"
            },
            {
              id: 70111,
              label: "业绩积分汇总表"
            },
            {
              id: 70121,
              label: "推荐积分明细查询表"
            },
            {
              id: 70131,
              label: "业绩积分明细查询表"
            },
            {
              id: 70141,
              label: "补货订单统计"
            },
            {
              id: 70151,
              label: "发货统计"
            },
            {
              id: 70161,
              label: "通联每日对账文件"
            },
            // {
            //   id: 70171,
            //   label: "CEO省代人数统计"
            // },
            {
              id: 70181,
              label: "禁用用户记录"
            },
            {
              id: 70191,
              label: "代理活跃度统计"
              },
            {
            id: 70201,
            label: "地区活跃度统计"
            },
            {
              id:70211,
              label: "区总奖励查询"
            },
            {
              id: 70221,
              label: "代理库存明细统计"
            },
            {
              id: 70231,
              label: "代理库存价值统计"
            },
            {
              id: 70291,
              label: "分公司订单统计"
            },
          ]
        },
        {
          id: 80001,
          label: "活动管理",
          children: [
            {
              id: 80011,
              label: "查看赠送活动"
            },
            {
              id: 80011991,
              label: "编辑赠送活动"
            }
          ]
        },
        {
          id: 90001,
          label: "音视频课程管理",
          children: [
            {
              id: 90011,
              label: "查看课程标签"
            },
            {
              id: 90011991,
              label: "编辑课程标签"
            },
            {
              id: 90012,
              label: "查看课程"
            },
            {
              id: 90012991,
              label: "编辑课程"
            },
            {
              id: 90013,
              label: "查看打卡积分"
            },
            {
              id: 90014,
              label: "每日打卡音频"
            },
            {
              id: 90015,
              label: "查看背景音乐"
            },
            {
              id: 90015991,
              label: "编辑背景音乐"
            },
            {
              id: 90016,
              label: "查看商学院课程"
            },
            {
              id: 90016991,
              label: "编辑商学院课程"
            },
            {
              id: 90017,
              label: "查看商学院课程类型"
            },
            {
              id: 90017991,
              label: "编辑商学院课程类型"
            },
            {
              id: 90018,
              label: "查看直播"
            }
            ,
            {
              id: 90018991,
              label: "编辑直播"
            },
            {
              id: 90019,
              label: "查看课程分类"
            }
            ,
            {
              id: 90019991,
              label: "编辑课程分类"
            }
          ]
        },
        {
          id: 110001,
          label: "物流端权限",
          children: [
            {
              id: 100002,
              label: "审批"
            },
            {
              id: 100001,
              label: "申领"
            },
            {
              id: 100003,
              label: "发货"
            }
            ,
            {
              id: 100004,
              label: "广州发货统计"
            }
          ]
        },
        {
          id: 120001,
          label: "活动管理",
          children: [
            {
              id: 120002,
              label: "查看"
            },
            {
              id: 120003,
              label: "编辑"
            }
          ]
        },
        {
          id: 130001,
          label: "利润统计",
          children: [
            {
              id: 130002,
              label: "查看"
            },

          ]
        }
      ],
      data3: [

        {
          id: 20001,
          label: "业务管理",
          children: [

            {
              id: 20031,
              label: "查看投诉"
            }

          ]
        },
        {
          id: 30001,
          label: "商城管理",
          children: [

            {
              id: 30021,
              label: "查看订单"
            },

            {
              id: 30041,
              label: "查看库存变动"
            },
            {
              id: 30081,
              label: "查看换货"
            },

          ]
        },
        {
          id: 40001,
          label: "用户管理",
          children: [

            {
              id: 40021,
              label: "查看代理"
            },
            {
              id: 40031,
              label: "查看代理申请"
            },
            {
              id: 40041,
              label: "查看门店"
            },
            {
              id: 40051,
              label: "门店搜索记录"
            },
            {
              id: 40071,
              label: "查看店铺修改审核"
            },
          ]
        },
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      roleLoading: false,
      dialogRoleVisible: false,
      dialogEditVisible: false,
      tableDataLoading: false,
      bankListVisible: false,
      addLoading: false,
      addLoading1: false,
      bankListVisibleLoading: false,
      searchUserId: null,
      addPassLoading: false,
      tableData1: [],
      dialogEditPassVisible: false,
      dialogEditVisible1: false,
      addUserRule: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        splitRatio: [
          {
            required: true,
            message: "请输入拆分比",
            trigger: "blur"
          }
        ],
        telephone: [
          {
            required: true,
            message: "请填写手机号",
            validator: validatePhone,
            trigger: "blur"
          }
        ],
        user_type: [
          {
            required: true,
            message: "请选择用户类型",
            trigger: "blur"
          }
        ],
        login_type: [
          {
            required: true,
            message: "请选择登录权限",
            trigger: "blur"
          }
        ]
      },
      editPassRule: {
        old_pass: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          }
        ],
        new_pass: [
          {
            required: true,
            message: "请输入新密码",
            trigger: "blur"
          }
        ],
        new_passN: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: "blur"
          }
        ],
        user_type: [
          {
            required: true,
            message: "请选择用户类型",
            trigger: "blur"
          }
        ],
        login_type: [
          {
            required: true,
            message: "请选择登录权限",
            trigger: "blur"
          }
        ]
      },

      editUserRule: {
        username: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        telephone: [
          {
            required: true,
            message: "请填写手机号",
            validator: validatePhone,
            trigger: "blur"
          }
        ],
      },
      form1: {
        id: null,
        old_pass: null,
        new_pass: null,
        new_passN: null,
        username: null,
        password:null,
        telephone: null,
        email: null,
        login_type:null,
        user_type:null,
        id_code: null,
        group_type: null
      },
      form: {
        id: null,
        old_pass: null,
        new_pass: null,
        new_passN: null,
        username: null,
        password:null,
        telephone: null,
        email: null,
        login_type:null,
        user_type:null,
        id_code: null,
        group_type: null,
        splitRatio: null,
      },
      filters: {
        title: null,
        status: null
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null,
      showSplitRatio: 0,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    formatterRoleType(row, column) {
      row.role_type = row.roleType
      var word = "";
      if (row.role_type != -1) {
        if (row.su_type == 1)
        {
          word = "束轩-";
        }
      }
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        word = "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        word = "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        word = "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word += "VIP门店";
      } else if (row.role_type == 1) {

        if (row.province_type == 4)
        {
          word += "康减康庭系列联盟店";
        } else if (row.province_type == 5) {
          word += "康颜单项联盟店";
        } else {
          word += "联盟店";
        }
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        if (row.province_type == 1)
        {
          word = "优秀省代";
        } else {
          word = "战略省代";
        }

      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 1.05) {
        word += "优秀联盟店";
      } else if (row.role_type == 5) {
        word += "总经销商";
      } else if (row.role_type == 6) {
        word += "销售公司";
      } else if (row.role_type == 2.2) {
        word +=  "合伙人";
      } else if (row.role_type == 4.2) {
        word +=  "董事";
      } else if (row.role_type == 5.1) {
        word +=  "区域总监";
      } else if (row.role_type == 5.2) {
        word +=  "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + "-" + "特殊";
      }
      return word;
    },
    changeSplitRatio(e){
      if(e>100){
        this.form.splitRatio = 100
      }
      if(e<0){
        this.form.splitRatio = 0
      }
      var ratio = this.form.splitRatio * 100
      this.showSplitRatio = ratio
    },
    handleNodeClick(data, checked) {
      //往treeNode里面添加元素
      this.roleForm.powers = JSON.parse(JSON.stringify(checked.checkedKeys));
      console.info(checked);

      // if (data.children && data.children != null) {
      //   for (var j = 0; j < data.children.length; j++) {
      //     var add = true;
      //     if (!checked) {
      //       add = false;
      //     }
      //     for (var i = 0; i < this.roleForm.powers.length; i++) {
      //       if (!checked) {
      //         if (parseInt(this.roleForm.powers[i]) == data.children[j].id) {
      //           this.roleForm.powers.splice(i, 1);
      //         }
      //       } else {
      //         if (parseInt(this.roleForm.powers[i]) == data.children[j].id) {
      //           add = false;
      //         }
      //       }
      //     }
      //     if (add) {
      //       this.roleForm.powers.push(data.children[j].id);
      //     }
      //   }
      // } else {
      //   console.info(JSON.stringify(this.roleForm.powers));
      //   var add = true;
      //   if (!checked) {
      //     add = false;
      //   }
      //   for (var i = 0; i < this.roleForm.powers.length; i++) {
      //     if (!checked) {
      //       console.info(this.roleForm.powers[i] + '-' + data.id + '-');
      //       if (this.roleForm.powers[i] == parseInt(data.id)) {
      //         this.roleForm.powers.splice(i, 1);
      //         break;
      //       }
      //     } else {
      //       if (parseInt(this.roleForm.powers[i]) == parseInt(data.id)) {
      //         add = false;
      //         break;
      //       }
      //     }
      //   }
      //   if (add) {
      //     this.roleForm.powers.push(data.id + '');
      //   }
      // }
    },
    showEditGroup1(row) {
      this.form.id = null;
      this.form.telephone = null;
      this.form.email = null;
      this.form.id_code = null;
      this.form.username = null;
      this.form.login_type = null;
      this.form.user_type = null;
      this.form.password = null;
      this.form.splitRatio = null;
      this.$nextTick(() => {
        if (this.$refs.addUserRule && this.$refs.addUserRule != null)
        {
          this.$refs.addUserRule.clearValidate()
        }
      });
      this.dialogEditVisible1 = true;
    },
    showEditGroup(row) {
      this.form1.id = row.id;
      this.form1.telephone = row.telephone;
      this.form1.email = row.email;
      this.form1.id_code = row.id_code;
      this.form1.username = row.username;
      this.form1.login_type = row.login_type + '';
      this.form1.user_type = row.user_type + '';
      this.$nextTick(() => {
        if (this.$refs.editUserRule && this.$refs.editUserRule != null)
        {
          this.$refs.editUserRule.clearValidate()
        }
      });
      this.dialogEditVisible = true;
    },
    goDetail(row) {
      this.$router.push({ path: "/user_detail", query: { id: row.id } });
    },

    changePass() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.id = para.id;
          para.splitRatio = para.splitRatio;
          para.token = localStorage.getItem("api_token");
          that.addPassLoading = true;
          API.up_out_black(para)
            .then(
              function(result) {
                that.addPassLoading = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.handleSearch();
                  that.dialogEditPassVisible = false;
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.addPassLoading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addPassLoading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    showRoleEditDialog(row) {
      this.roleForm.id = row.id;
      if (row.powers != null && row.powers != '') {
        this.roleForm.powers = row.powers.split(",");
      } else {
        this.roleForm.powers = [];
      }
      if (this.roleForm.powers.length > 0) {
        for (var i=0; i<this.roleForm.powers.length; i++) {
          this.roleForm.powers[i] = parseInt(this.roleForm.powers[i]);
        }
        this.powers = JSON.parse(JSON.stringify(this.roleForm.powers));
      }
      if (row.user_type == 1)
      {
        this.data4 = this.data2
      } else
      {
        this.data4 = this.data3
      }
      if (this.$refs.tree2) {
        this.$refs.tree2.setCheckedNodes(this.powers);
      }
      this.dialogRoleVisible = true;
    },
    editRole() {
      let that = this;
      that.$refs["roleForm"].validate(valid => {
        if (valid) {
          if (that.roleForm.powers.length == 0) {
            that.$message.error({
              showClose: true,
              message: "请至少选择一个权限",
              duration: 2000
            });
            return;
          }
          let para = {
            id: that.roleForm.id,
            powers: that.roleForm.powers.join(",")
          };
          para.token = localStorage.getItem("api_token");
          that.roleLoading = true;
          API.edit_manager_user_role(para)
            .then(
              function(result) {
                that.roleLoading = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.search();
                  that.dialogRoleVisible = false;
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.roleLoading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.roleLoading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },

    throwGroupUp() {
      let that = this;
      that.$refs["form1"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form1);

          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.add_up_manager_user(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.dialogEditVisible = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.addLoading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },

    throwGroupUp1() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.addLoading1 = true;
          API.up_out_black(para)
            .then(
              function(result) {
                that.addLoading1 = false;
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.dialogEditVisible1 = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.addLoading1 = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.addLoading1 = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    formatterStatus(row, column) {
      if (row.status == 1) {
        return "可用";
      } else if (row.status == 2) {
        return "禁用";
      }
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },
    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("确定禁用该黑名单吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: status
            };
            API.up_out_black_status(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "禁用成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
        this.form.id = row.id;
        this.form.splitRatio = row.splitRatio;
        this.dialogEditPassVisible = true;
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定恢复该黑名单吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id,
              status: status
            };
            API.up_out_black_status(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "恢复成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.keyword = that.filters.title;
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      that.tableDataLoading = true;
      API.out_black_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/user/normal_user_out_black_list.vue